import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    standalone: false,
    templateUrl: "./oauth-callback.component.html",
})
export class OAuthCallBack implements OnInit {
    constructor(
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            if (params['code']) {
                // Send the code to the parent window
                if (window.opener) {
                    window.opener.postMessage({ type: 'oauth_callback', code: params['code'] }, window.location.origin);
                    window.close();
                }
            }
        });
    }
}
